// useIdleTimer.js - Auto-logout on user inactivity
import { useEffect, useRef } from 'react';

const useIdleTimer = (onIdle, idleTime = 15 * 60 * 1000) => { // Default 15 minutes
  const timeoutId = useRef(null);

  const resetTimer = () => {
    // Clear existing timeout
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    // Set new timeout
    timeoutId.current = setTimeout(() => {
      onIdle();
    }, idleTime);
  };

  useEffect(() => {
    // Events that indicate user activity
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click',
      'keydown'
    ];

    // Reset timer on any user activity
    const handleActivity = () => {
      resetTimer();
    };

    // Add event listeners
    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    // Initialize timer
    resetTimer();

    // Cleanup
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [idleTime, onIdle]);

  return resetTimer;
};

export default useIdleTimer;
